<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('avi-to-mp3-converter', 'AVI → MP3');

function handleBatchCreated(batchId: string) {
  console.log('[AVI-to-MP3 Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[AVI-to-MP3 Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[AVI-to-MP3 Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[AVI-to-MP3 Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[AVI-to-MP3 Converter] Credits updated:', credits);
}
</script>
